import { render, staticRenderFns } from "./complex.vue?vue&type=template&id=54b12c9f&scoped=true&functional=true"
var script = {}
import style0 from "./complex.vue?vue&type=style&index=0&id=54b12c9f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "54b12c9f",
  null
  
)

export default component.exports